import React, { Fragment, useEffect, useState } from 'react';
import ShiftDetails from './ShiftDetails';

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import './css/table-styles.css'
const ListShifts = () => {

    const [shifts, setShifts] = useState([]);
    const [worker_name, setWorker_name] = useState("")

    const getShifts = async () => {
        try {
            const response = await fetch("https://www.beyondcommunityaccess.com/shifts", {
                method: "GET",
                headers: { token: localStorage.token }
            });
            const jsonDataReq = await response.json();

            var displayData = [];
            if (jsonDataReq.worker_name[0].worker_name === undefined) {
                setWorker_name("Database Error");
            } else {
                setWorker_name(jsonDataReq.worker_name[0].worker_name);
            }
            var jsonData = jsonDataReq.shifts;

            jsonData.sort((a, b) => {
                var dif = parseInt(b.start_time) - parseInt(a.start_time);
                if (dif === 0) {
                    return parseInt(b.end_time) - parseInt(a.end_time);
                } else {
                    return dif;
                }
            });

            for (var i = 0; i < jsonData.length; i++) {
                var expanded = {};
                var temp_shift = {};
                temp_shift.shift_id = jsonData[i].shift_id;
                temp_shift.client_name = jsonData[i].name;
                if (jsonData[i].has_expenses) {
                    temp_shift.has_expenses = "Present"
                } else {
                    temp_shift.has_expenses = "Vacant"
                }
                var temp_time = new Date(parseInt(jsonData[i].start_time));
                expanded.start_date_time = temp_time.toLocaleString();
                temp_shift.date = temp_time.toLocaleDateString();

                var start_hours = "Contact support";
                var start_minutes = "Contact support";
                if (temp_time.getHours() < 10) {
                    start_hours = '0' + temp_time.getHours();
                } else {
                    start_hours = temp_time.getHours();
                }
                if (temp_time.getMinutes() < 10) {
                    start_minutes = '0' + temp_time.getMinutes()
                } else {
                    start_minutes = temp_time.getMinutes()

                }
                temp_shift.start_time = start_hours + ":" + start_minutes;

                temp_time = new Date(parseInt(jsonData[i].end_time));
                expanded.end_date_time = temp_time.toLocaleString();
                var end_hours = "Contact support";
                var end_minutes = "Contact support";
                if (temp_time.getHours() < 10) {
                    end_hours = '0' + temp_time.getHours();
                } else {
                    end_hours = temp_time.getHours();
                }
                if (temp_time.getMinutes() < 10) {
                    end_minutes = '0' + temp_time.getMinutes()
                } else {
                    end_minutes = temp_time.getMinutes()

                }
                temp_shift.end_time = end_hours + ":" + end_minutes;

                temp_shift.metres = jsonData[i].m_travelled;
                temp_shift.description = jsonData[i].description.substring(0, 10);
                if (jsonData[i].description.length > 10) {
                    temp_shift.description += '...'
                }

                expanded.description = jsonData[i].description;
                expanded.expenses = jsonData[i].expenses;
                expanded.worker_name = worker_name;
                temp_shift.expanded = expanded;

                displayData.push(temp_shift);
            }

            setShifts(displayData);
        } catch (err) {
            console.error("Failed: getting all a user's shifts");
            console.error(err.message);
        }
    }

    useEffect(() => {
        getShifts();
    }, [])
    return (
        <Fragment>
            <div className="container">
                <h1 className="mt-5">Shift List for {worker_name}</h1>
                <Table className="table mt-5 text-center">
                    <Thead>
                        <Tr>
                            <Th>Client Name</Th>
                            <Th>Date</Th>
                            <Th>Start Time</Th>
                            <Th>End Time</Th>
                            <Th>Kilometres Travelled</Th>
                            <Th>Has Expenses</Th>
                            <Th>Description</Th>
                            <Th>Expand</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {/* <Tr>
                        <Td>John</Td>
                        <Td>Doe</Td>
                        <Td>john@example.com</Td>
                    </Tr> */}
                        {shifts.map(shift => (
                            <Tr key={shift.shift_id}>
                                <Td>{shift.client_name}</Td>
                                <Td>{shift.date}</Td>
                                <Td>{shift.start_time}</Td>
                                <Td>{shift.end_time}</Td>
                                <Td>{shift.metres}</Td>
                                <Td>{shift.has_expenses}</Td>
                                <Td>{shift.description}</Td>
                                <Td><ShiftDetails shift={shift} /></Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </div >
        </Fragment>
    );
}

export default ListShifts;

// const body = { temp_worker_id, client, start, end, expenses, m_travelled, description };
